<form [formGroup]="datesForm">
  <div class="date-picker" (click)="picker.open()" [ngClass]="{ filled: datesForm.get('date')?.value }">
    <img class="date-picker-icon" src="assets/images/common/date.svg" alt="date" />
    <div *ngIf="!datesForm.get('date')?.value">
      <div class="date-picker-title">{{ label | labelsProvider }}</div>
    </div>
    <div class="date-picker-with-dates" *ngIf="datesForm.get('date')?.value">
      {{ datesForm.get('date')?.value | date }}
    </div>
    <input
      class="date-picker-input"
      matInput
      [matDatepicker]="picker"
      formControlName="date"
      [max]="maxDate ? maxDate : today"
      [min]="minDate"
    />
    <mat-datepicker #picker></mat-datepicker>
    <div class="picker-icons">
      <img
        *ngIf="datesForm.get('date')?.value"
        class="date-picker-cancel"
        src="assets/images/common/cancel.svg"
        (click)="clearForm(); $event.stopPropagation()"
        alt="cancel"
      />
      <img src="assets/images/arrows/empty-arrow-down.svg" class="drop-down" alt="expand" />
    </div>
  </div>
</form>
